export class FieldError {
    public fieldName: string;
    public errorMessage: string;

}
